import { useRoutes } from 'react-router-dom'
import { useState } from 'react'

import HomePage from './pages/home'
import AboutPage from './pages/about'
import SuperheroesPage from './pages/superheroes'
import SuperheroPage from './pages/superhero'
import ResearchPage from './pages/research'
import ContactPage from './pages/contact'
import QuizPage from './pages/quiz'
import QuizPBasket from './pages/quiz_pBasket'
import QuizPhase1 from './pages/quiz_phase1'
import QuizPhase2 from './pages/quiz_phase2'
import QuizResultPage from './pages/quiz_result'
import QuizRelevantPage from './pages/quiz_relevant'
import ErrorPage from './pages/error'

import { getQuestions } from './services/service'

const AppRouter = () => {
  const [pBasket, setPBasket] = useState<string[]>([])

  return useRoutes([
    { path: '/', element: <HomePage /> },
    { path: '/about', element: <AboutPage /> },
    { path: '/superheroes', element: <SuperheroesPage /> },
    { path: '/superhero/:id', element: <SuperheroPage /> },
    { path: '/research', element: <ResearchPage /> },
    { path: '/contact', element: <ContactPage /> },
    { path: '/quiz', element: <QuizPage /> },
    {
      path: '/quiz-p',
      element: <QuizPBasket pBasket={pBasket} setPBasket={setPBasket} />,
    },
    { path: '/quiz-v1', element: <QuizPhase1 /> },
    {
      path: '/quiz-v2',
      element: <QuizPhase2 questions={getQuestions(pBasket)} />,
    },
    { path: '/quiz-result/:id', element: <QuizResultPage /> },
    { path: '/quiz-relevant/:id', element: <QuizRelevantPage /> },
    { path: '*', element: <ErrorPage /> },
  ])
}

export default AppRouter
